import Icons from "@/assets";

export const badgesData = [
    {
        id: "new",
        name: "New Contributor",
        description: "Make 1 contribution",
        target: 1,
        icon: Icons.NewContributor,
    },
    {
        id: "active",
        name: "Active Contributor",
        description: "Make 5 contributions",
        target: 5,
        icon: Icons.ActiveContributor,
    },
    {
        id: "trusted",
        name: "Trusted Contributor",
        description: "Make 10 contributions",
        target: 10,
        icon: Icons.TrustedContributor,
    },
    {
        id: "highly",
        name: "Highly Trusted",
        description: "Make 15 contributions",
        target: 15,
        icon: Icons.HighlyTrusted,
    },
];
